export default "__VITE_ASSET__bnMh5wgS__"